import React from 'react'
import _, { groupBy, map, reduce } from 'lodash'
import { Component } from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { convertSearchObjectToBase64 } from 'utils/objToBase64'
import Moment from 'moment'

import { Get, Post, Put } from 'utils/axios-token'
import { setSelectCenter } from 'actions/selectCenter'
import { defaultFormVal } from '../DialogsSettings/assets'

import Lang from 'Lang/General'

const HOC = (WrappedComponent) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      dialogs: [],
      selectedDialogue: {},
      selectedDialogMessages: [],
      subscribedPackage: true,
      query: {},
      isDialogueLoaded: false,
      dialogueSetting: {},
      isDialogueSettingLoaded: false,
      dialogueFields: [],
      dialogueFieldErrors: {},
      isDialogueFieldsFilled: false,
      dialogueMessage: DEFAULT_MESSAGE,
      internalDialogueMessage: DEFAULT_MESSAGE,
      lastMessageId: 0,
      lastInternalMsgId: 0,
      selectedSetting: defaultFormVal,
      selectedCompanyField: {},
      isParticipant: false,
      showEnd: false
    }

    onChangeDialogsHOC = (key, val) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success(success)
    requestError = error => toast.error(error)

    getDialogs = () => {
      Get(
        `/api/v1/dialogues/${this.props.data.selectCenterReducer.selectedCenter.center.id}?query=${convertSearchObjectToBase64({
          "is_paginated": false,
          "page": 1,
          "filter": {
            "status": "ACTIVE"
          }
        })}`,
        this.getDialogsSuccess,
        () => {},
        () => {}
      )
    }
    getDialogsSuccess = payload => this.setState({ dialogs: payload.data })

    createAndUpdateDialogueFieldsInfos = () => Post(
      `/api/v1/dialoguefields/support/${ this.props.data.selectCenterReducer.selectedCenter.center.id }/${ this.state.selectedDialogue.encrypted_id }`,
      this.state.dialogueFields,
      this.createAndUpdateDialogueFieldsInfosSuccess,
      this.createAndUpdateDialogueFieldsInfosError,
      this.load
    )
    createAndUpdateDialogueFieldsInfosSuccess = () => {
      this.setState({ isDialogueFieldsFilled: false, dialogueFieldErrors: {} })
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.getDialogs()
      this.getSelectedDialogue( this.state.selectedDialogue.encrypted_id )
    }
    createAndUpdateDialogueFieldsInfosError = err => this.setState({ dialogueFieldErrors: err })

    createDialogueMessage = isInternalDialogue => Post(
      `/api/v1/dialoguemessages/${ this.state.selectedDialogue.encrypted_id }`,
      {
        is_internal: isInternalDialogue,
        ... !isInternalDialogue 
          ? this.state.dialogueMessage
          : this.state.internalDialogueMessage,
        ... !this.state.isParticipant && {
          last_read_message_id: this.state.lastMessageId,
        }
      },
      () => this.createDialogueMessageSuccess(isInternalDialogue),
      this.createDialogueMessageError,
      this.load
    )
    createDialogueMessageSuccess = isInternalDialogue => {
      if(!isInternalDialogue){
        this.setState({ 
          dialogueMessage: DEFAULT_MESSAGE
        })
      } else {
        this.setState({ 
          internalDialogueMessage: DEFAULT_MESSAGE
        })
      }
      this.getDialogs()
      this.getSelectedDialogue( this.state.selectedDialogue.encrypted_id )
    }
    createDialogueMessageError = () => {}

    getSelectedDialogue = id => Get(
      `/api/v1/dialogues/support/${ id }`,
      this.getSelectedDialogueSuccess,
      this.getSelectedDialogueError,
      () => {}
    )
    getSelectedDialogueSuccess = payload => {
      let tmpMessages = []
      let tmpParticipants = reduce( 
        payload.dialogue_participants,
        ( result, participant ) => ({
          ...result,
          [ participant.id ]: {
            ...participant,
            name: `${ participant.first_name } ${ participant.last_name }`
          }
        }),
        {}
      )

      let tempFind = _.findIndex(payload.dialogue_participants, child => child.user_id === this.props.data.profileReducer.profile.id)

      map(
        groupBy( 
          payload.dialogue_messages,
          message => Moment( message.created_at ).format( 'YYYY-MM-DD' )
        ),
        ( value, key ) => {
          tmpMessages.push({
            date: Moment( key, 'YYYY-MM-DD' ).format( 'dddd, DD.MM.YYYY' ),
            messages: value
          })
        }
      )

      let tempFilteredParticipants = []
      _.map(payload.dialogue_participants, child => {
        if(child.user_id !== this.props.data.profileReducer.profile.id) {
          tempFilteredParticipants.push(child.id)
        }
      })

      let tempFilteredMsg = _.filter(payload.dialogue_messages, child => {
        return tempFilteredParticipants.indexOf(child.dialogue_participants_id) > -1
      })

      this.setState({ 
        isDialogueLoaded: true,
        isParticipant: tempFind > -1,
        lastMessageId: tempFilteredMsg[ tempFilteredMsg.length - 1 ]?.id,
        lastInternalMsgId: payload.internal_messages[ payload.internal_messages.length - 1 ]?.id,
        selectedDialogue: {
          ...payload,
          dialogue_messages: tmpMessages,
          dialogue_participants: tmpParticipants,
          onCheckParticipants: _.map(tmpParticipants, child => child.user_id).indexOf(this.props.data.profileReducer.profile.id) > -1
        }
      })
    }
    getSelectedDialogueError = () => this.setState({ isDialogueLoaded: true })

    getDialogueSetting = () => Get(
      `/api/v1/dialogues/centers/support/${ this.props.data.selectCenterReducer.selectedCenter.center.id }`,
      this.getDialogueSettingSuccess,
      this.getDialogueSettingError,
      this.load
    )
    getDialogueSettingSuccess = payload => this.setState({ 
      dialogueSetting: payload,
      isDialogueSettingLoaded: true
    })
    getDialogueSettingError = () => {}

    updateLastRead = (dataToSubmit) => Put(
      `/api/v1/dialoguesparticipants`,
      dataToSubmit,
      () => this.updateLastReadSuccess(dataToSubmit),
      this.updateLastReadError,
      this.load
    )
    updateLastReadSuccess = val => {
      this.setState({
        selectedDialogue: {
          ... this.state.selectedDialogue,
          last_message: {
            ... this.state.selectedDialogue.last_message,
            id: val.last_read_message_id
          }
        }
      })
      this.getDialogs()
      this.getSelectedDialogue( this.state.selectedDialogue.encrypted_id )
    }
    updateLastReadError = error => {}

    closeDialog = id => Put(
      `/api/v1/dialogues/close/${id}`,
      {},
      this.closeDialogSuccess,
      this.closeDialogError,
      this.load
    )
    closeDialogSuccess = () => {
      this.requestSuccess(Lang['RECORD_UPDATE_SUCCESS'][this.props.data.languageReducer.userSettings.admin_panel_language])
      this.setState({
        selectedDialogue: {},
        showEnd: false
      }, () => this.getDialogs())
    }
    closeDialogError = error => this.requestError(error)

    render = () => {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          onLoadDialogsHOC={this.state.loading}
          closeDialog={this.closeDialog}
          requestSuccess={this.requestSuccess}
          getDialogs={this.getDialogs}
          updateLastRead={this.updateLastRead}
          onChangeDialogsHOC={this.onChangeDialogsHOC}
          createAndUpdateDialogueFieldsInfos={ this.createAndUpdateDialogueFieldsInfos }
          createDialogueMessage={ this.createDialogueMessage }
          getSelectedDialogue={ this.getSelectedDialogue }
          getDialogueSetting={ this.getDialogueSetting }
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect(mapStateToProps, {setSelectCenter})(WithHOC)
}

const DEFAULT_MESSAGE = {
  content: '',
  dialogue_attachments: []
}

export default HOC